import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-6987833a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "样本信息", -1); });
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("手术");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("穿刺");
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "检测项目信息", -1); });
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "签字确认", -1); });
var _hoisted_12 = {
    key: 1,
    class: "sign-box"
};
var _hoisted_13 = ["src"];
import { computed } from "vue";
import { Form, Field, RadioGroup, Radio } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'otherInfo',
    props: {
        otherInfo: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var sampleTypeLabel = computed(function () {
            var _a;
            return (_a = [
                {
                    value: "surgery_puncture_fresh_tissue",
                    text: "新鲜组织",
                },
                {
                    value: "other",
                    text: "其他样本",
                },
                {
                    value: "paraffin_section",
                    text: "石蜡切片",
                },
                {
                    value: "paraffin_roll",
                    text: "石蜡卷",
                },
                {
                    value: "parffin_block",
                    text: "石蜡快",
                },
            ].find(function (item) { return item.value === props.otherInfo.sampleType; })) === null || _a === void 0 ? void 0 : _a.text;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Form), null, {
                        default: _withCtx(function () {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return [
                                _hoisted_3,
                                _createVNode(_unref(Field), {
                                    "model-value": (_a = props.otherInfo) === null || _a === void 0 ? void 0 : _a.samplingTime,
                                    readonly: "",
                                    label: "采样时间"
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_b = props.otherInfo) === null || _b === void 0 ? void 0 : _b.samplingSite,
                                    label: "采样部位",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), { label: "是否为原发灶" }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.otherInfo) === null || _a === void 0 ? void 0 : _a.primaryTumor,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_4
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_5
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    "model-value": _unref(sampleTypeLabel),
                                    readonly: "",
                                    label: "样本类型"
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), { label: "切片形式" }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.otherInfo) === null || _a === void 0 ? void 0 : _a.sliceForm,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: "OPERATION"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_6
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: "PUNCTURE"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_7
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    readonly: "",
                                    label: _unref(sampleTypeLabel),
                                    "model-value": (_c = props.otherInfo) === null || _c === void 0 ? void 0 : _c.sampleNum
                                }, null, 8, ["label", "model-value"]),
                                _hoisted_8,
                                _createVNode(_unref(Field), {
                                    label: "既往接受过肿瘤基因检测",
                                    "label-width": "11em"
                                }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.otherInfo) === null || _a === void 0 ? void 0 : _a.hadTest,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_9
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_10
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                ((_d = props.otherInfo) === null || _d === void 0 ? void 0 : _d.hadTest)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_unref(Field), {
                                            "model-value": (_e = props.otherInfo) === null || _e === void 0 ? void 0 : _e.testTime,
                                            readonly: "",
                                            label: "检测时间"
                                        }, null, 8, ["model-value"]),
                                        _createVNode(_unref(Field), {
                                            "model-value": (_f = props.otherInfo) === null || _f === void 0 ? void 0 : _f.testResult,
                                            label: "检测结果",
                                            readonly: ""
                                        }, null, 8, ["model-value"])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _hoisted_11,
                                ((_g = props.otherInfo) === null || _g === void 0 ? void 0 : _g.userSign)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("div", {
                                            style: _normalizeStyle({
                                                transform: 'rotate(90deg)',
                                            })
                                        }, [
                                            _createElementVNode("img", {
                                                class: "esign-img",
                                                src: (_h = props.otherInfo) === null || _h === void 0 ? void 0 : _h.userSign
                                            }, null, 8, _hoisted_13)
                                        ], 4)
                                    ]))
                                    : _createCommentVNode("", true)
                            ];
                        }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
